const updateMetaTitle = (data) => {

    let metaTitle = 'Cloud MT';
    if (typeof data === 'object') {
        metaTitle = data && data.meta && data.meta.title
            ? data.meta.title
            : 'Loading ... ';
    }
    else if (typeof data === 'string') {
        metaTitle = data;
    }

    updateDocumentTitle(metaTitle);
};

const updateDocumentTitle = (titleValue) => {
    document.title = `${titleValue} | Cloud MT by Citrus-Lime Ltd`;
};

export default updateMetaTitle;
